import { getClientAuthToken } from "./apiAuth";

function getBackendUrl() {
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

export const REGISTERED_SENT_ME_KEY = "fl_registered_sent_me";
export const SETTINGS_COMPLETED_SENT_ME_KEY = "fl_settings_completed_sent_me";

async function postLeadEvent(body) {
  const backendUrl = getBackendUrl();
  if (!backendUrl) {
    return { ok: false, skipped: true };
  }

  const res = await fetch(`${backendUrl}/api/marketing/lead-events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(`lead event failed: ${res.status}${detail ? ` ${detail}` : ""}`);
  }

  return res.json();
}

async function postAuthenticatedLeadEvent(body) {
  const backendUrl = getBackendUrl();
  const token = getClientAuthToken();
  if (!backendUrl) {
    return { ok: false, skipped: true, reason: "backend_unconfigured" };
  }
  if (!token) {
    return { ok: false, skipped: true, reason: "no_auth" };
  }

  const res = await fetch(`${backendUrl}/api/marketing/lead-events/me`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    keepalive: true,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(`lead event failed: ${res.status}${detail ? ` ${detail}` : ""}`);
  }

  return res.json();
}

export function sendLeadEvent({ leadId, engagement, productActivation, occurredAt }) {
  if (!leadId) {
    return Promise.resolve({ ok: false, skipped: true });
  }

  return postLeadEvent({
    lead_id: leadId,
    ...(occurredAt ? { occurred_at: occurredAt } : {}),
    ...(engagement ? { engagement } : {}),
    ...(productActivation ? { product_activation: productActivation } : {}),
  });
}

export function trackVslPageOpened(leadId) {
  return sendLeadEvent({
    leadId,
    engagement: { vsl_page_opened: true },
  });
}

export function trackVideoWatchedPercentage(leadId, percentage) {
  return sendLeadEvent({
    leadId,
    engagement: { video_watched_percentage: percentage },
  });
}

export async function trackProductActivationIfAuthenticated(productActivation, dedupKey) {
  if (localStorage.getItem(dedupKey)) {
    return { ok: false, skipped: true, reason: "already_sent" };
  }

  const result = await postAuthenticatedLeadEvent({
    product_activation: productActivation,
  });

  if (result?.skipped) {
    return { ok: false, skipped: true, reason: result.reason || "skipped" };
  }

  localStorage.setItem(dedupKey, "1");
  return { ok: true };
}

export function trackRegistrationIfAuthenticated() {
  return trackProductActivationIfAuthenticated(
    { is_registered: true },
    REGISTERED_SENT_ME_KEY,
  );
}

/** @deprecated Use trackRegistrationIfAuthenticated */
export async function trackRegistrationIfAttributed() {
  return trackRegistrationIfAuthenticated();
}

export function trackSettingsCompletedIfAuthenticated() {
  return trackProductActivationIfAuthenticated(
    { is_settings_completed: true },
    SETTINGS_COMPLETED_SENT_ME_KEY,
  );
}

/** @deprecated Use trackSettingsCompletedIfAuthenticated */
export async function trackSettingsCompletedIfAttributed() {
  return trackSettingsCompletedIfAuthenticated();
}
